import React, { Component } from 'react';
import './App.css';

import { Provider } from 'react-redux';
import { createStore } from 'redux';
import { reducer, startGame, placeSquare } from './Game/State';

import Game from './Game/Game';
import Menu from './Menu';
import AppStatus from './AppStatus';

import ReconnectingWebSocket from 'reconnectingwebsocket';

const store = createStore(reducer);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { name: 'Tic-Tac-Toe', gamemode: '', gamecode: '', connected: false, numberUsers: 0, localPlayers: [] };

    this.headerClick = this.headerClick.bind(this);
    this.sendMove = this.sendMove.bind(this);
  }

  componentDidMount() {
    // this.ws = new ReconnectingWebSocket('ws://' + window.location.hostname + ':3012/');
    console.log('ws://' + window.location.host + '/ws/');
    this.ws = new ReconnectingWebSocket('wss://' + window.location.host + '/ws/');

    this.ws.onopen = () => {
      console.debug('Connected to web socket');

      this.setState({ connected: true });

      // this.onChoice('hvgh', 'ks23fa');
      // this.ws.send(JSON.stringify({ large: [0, 0], small: [0, 0] }));
    };

    this.ws.onmessage = event => {
      let response;
      try {
        response = JSON.parse(event.data);
      } catch (e) {
        console.error(`Error parsing response from server. ${event.data} ${e}`);
        alert('There was an error please try again');
      }

      console.debug('Got response from server:', response);

      if (response.event) {
        switch (response.event.name) {
          case 'JOINED_GAME':
            this.setState({ gamecode: response.event.details });

            if (this.state.gamemode === 'spectate') {
              // Catch up game if in spectate mode
              this.ws.send(JSON.stringify({ request: 'CATCH_UP', start: 1 }));
            }
            break;
          case 'PLAYER_JOINED_LEFT':
            this.setState({ numberUsers: response.event.details });
            break;
          case 'ACTION':
            const action = response.event.details;
            // Action is probably too new, so we missed at least one previous action
            if (action.turn !== store.getState().turnNumber + 1) {
              console.debug(`Received turn number of ${action.turn} should be at ${store.getState().turnNumber + 1}, so catching up`);
              this.ws.send(JSON.stringify({ request: 'CATCH_UP', start: store.getState().turnNumber + 1 }))
            } else store.dispatch(placeSquare(action.large[0], action.large[1], action.small[0], action.small[1]));
            break;
          case 'CATCH_UP':
            console.log()
            const actions = response.event.details;

            for (const action of actions) {
              // Action is probably too old, could happen due to double catch_up request
              if (action.turn !== store.getState().turnNumber + 1) {
                console.debug(`During catch up got ${action.turn} should be at ${store.getState().turnNumber + 1}`)
              } else {
                console.debug(`Catching up turn: ${action.turn}`);
                store.dispatch(placeSquare(action.large[0], action.large[1], action.small[0], action.small[1]));
              }
            }
            break;
          default:
            console.error('Unrecognised event', response.event.name);
        }
      } else if (response.Action) {
        let action = response.Action;
        store.dispatch(placeSquare(action.large[0], action.large[1], action.small[0], action.small[1]));
      } else if(response.gamecode) {
        this.setState({ gamecode: response.gamecode })
      } else if(response.error) {
        console.error(response.error);
      } else if(response.Join) {
        this.setState({ numberUsers: response.Join });
      } else if(response.Leave) {
        this.setState({ numberUsers: response.Leave });
      } else {
        console.error('Unrecognised response from websocket', response);
      }
    };

    this.ws.onclose = event => {
      console.log('Disconnected from web socket. Reason:', event);
      this.setState({ connected: false });
    }
  }

  componentWillUnmount() {
    // this.ws.close()
  }

  headerClick() {
    this.setState(prevState => ({ name: prevState.name === 'Tic-Tac-Toe'? 'Noughts and Crosses': 'Tic-Tac-Toe' }));
  }

  // Sends local move to over websocket
  sendMove(large, small) {
    this.ws.send(JSON.stringify({ turn_count: store.getState().turnNumber, action: { large, small } }));
  }

  onChoice(choice, gamecode) {
    switch (choice) {
      case 'hvlh':
        store.dispatch(startGame(choice, ['x', 'o']));
        break;
      case 'hvgh':
        store.dispatch(startGame(choice, gamecode === ''? ['x']: ['o']));
        break;
      case 'hva':
        store.dispatch(startGame(choice, ['x']));
        break;
      case 'spectate':
        store.dispatch(startGame(choice, []));
        break;
      default:
        console.error(`Unrecognised choice ${choice}`);
    }


    this.ws.send(JSON.stringify({ gamemode: choice.toUpperCase(), gamecode }));

    this.setState({ gamemode: choice, localPlayers: store.getState().localPlayers });
  }

  render() {
    return (
      <Provider store={store}>
        <div className="App">
          <header className="App-header">
            <h1 className="App-Title" onClick={ this.headerClick }>Ultimate { this.state.name }</h1>
            <AppStatus connected={ this.state.connected } localPlayers={this.state.localPlayers} gamecode={ this.state.gamecode } numberUsers={ this.state.numberUsers } />
          </header>
          { this.state.gamemode === ''? <Menu onChoice={ this.onChoice.bind(this) } />:
            <Game onMove={ this.sendMove } />}
        </div>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js